import { useForm } from "react-hook-form";
import Checkbox from "src/components/Checkbox";

const Declaration = ({ onSubmit }) => {
  // Form
  const { register, handleSubmit, formState } = useForm({
    defaultValues: { Declaration: false },
  });
  const { errors, isSubmitting } = formState;

  return (
    <>
      <h2>Declaration</h2>

      <div className="form-terms">
        <h3>Learning Agreement Declaration & Terms and Conditions</h3>

        <p>
          I, the learner, agree to South Central Institute of Technology
          processing the personal data contained in this form for any purposes
          connected with my studies or my health and safety whilst on the
          premises or for any other legitimate and reasonable reason. This will
          include the forwarding of information I provide at enrolment to the
          Education and Skills Funding Agency for England, which is also
          registered under the Data Protection Act 1998. The registration is
          primarily for the collection and analysis of statistical data, but it
          also allows the Agency to share information with organisations for the
          purpose of detecting fraud. I agree that my data will be used for a
          full range of marketing/alumni activities, including sending Institute
          publications, promotion of benefits and services available to alumni.
          I understand that Milton Keynes Institute is required to record
          progression data and I agree to provide details of employment as
          required. I understand that my course may be part/match funded by the
          ESF.
        </p>
        <p>
          Where applicable, In order to assist my choice of course, I have
          received guidance from the Institute about its suitability to my
          needs, advice on learning and financial support where appropriate.
          Guidance has been received in either written materials, such as
          leaflets or a prospectus, and/or by discussions with an appropriate
          member of Institute staff that may have included any
          interview/assessment.
        </p>
        <p>
          I confirm that I have been made aware of the Institute Fees Policy and
          understand that, if I have declared false information, action to
          reclaim course fees may be taken against me. I accept that the
          Institute has the right to share information about my attendance and
          progress with my parent(s) / carer(s) if I am aged under 19, and with
          my employer / sponsor if they are paying my fees. I agree to my
          photograph being taken and understand that it may be used to promote
          the Institute. Any objection to this arrangement should be put in
          writing to the Marketing Department at the Institute. I understand
          that I am responsible for my own learning and behaviour, and my
          conduct should be in line with all Institute policies to ensure an
          environment where people feel respected, safe and secure, and are able
          to learn effectively. I agree to behave in a way that will not
          adversely affect others and abide by the Institute policy surrounding
          the use of IT systems, which will be communicated at induction and can
          also be found on the Institute's Virtual Learning Environment.
        </p>

        <h4>HOW WE USE YOUR PERSONAL INFORMATION</h4>
        <p>
          This privacy notice is issued by the Education and Skills Funding
          Agency (ESFA), on behalf of the Secretary of State for the Department
          of Education (DfE). It is to inform learners how their personal
          information will be used by the DfE, the ESFA (an executive agency of
          the DfE) and any successor bodies to these organisations. For the
          purposes of the Data Protection Act 1998, the DfE is the data
          controller for personal data processed by the ESFA. Your personal
          information is used by the DfE to exercise its functions and to meet
          its statutory responsibilities, including under the Apprenticeships,
          Skills, Children and Learning Act 2009 and to create and maintain a
          unique learner number (ULN) and a personal learning record (PLR). Your
          information may be shared with third parties for education, training,
          employment and well-being related purposes, including for research.
          This will only take place where the law allows it and the sharing is
          in compliance with the Data Protection Act 1998. The English European
          Social Fund (ESF) Managing Authority (or agents acting on its behalf)
          may contact you in order for them to carry out research and evaluation
          to inform the effectiveness of training.
        </p>
        <p>
          Further information about use of and access to your personal data, and
          details of organisations with whom we regularly share data are
          available at:
          <a
            href="https://www.gov.uk/government/publications/esfa-privacy-notice"
            target="_blank"
          >
            https://www.gov.uk/government/publications/esfa-privacy-notice
          </a>
        </p>

        <h4>FEES</h4>

        <p>
          'Fees' refers to the charges passed on to a student in respect to
          educational services, this includes tuition, examination and
          assessment costs. Fees paid will be dependent on age, personal
          circumstances as well as type and level of the course. All fees will
          be explained to a student prior to enrolment. This Fee Policy applies
          to all learners starting new learning aims on or after 1st August
          2017.
        </p>
        <p>
          Fees must be paid before or at Enrolment. The enrolment process will
          not be completed until all fees are paid in full or an approved
          payment plan has been agreed with the institute. Enrolment on a course
          will be refused where there are outstanding fees relating to previous
          enrolments. The Institute uses information disclosed by the learner at
          enrolment to determine a student's fees. The Institute reserves the
          right to re-assess fees if it discovers this information given at
          enrolment is incorrect. Fees are charged based on an individual's
          status at the time of enrolment; changes to this status post enrolment
          will not affect the fee status. The Institute reserves the right to
          take reasonable steps to recover unpaid fees, including using an
          external debt collection agency. The Institute reserves the right to
          vary fees without notice at any time up to the start of a programme.
          Where students are on a funded course we will apply all fee remissions
          as set out by the relevant funding agency. In the event that a
          relevant funding agency changes its fee remission criteria, the
          Institute reserves the right to collect/waive fees accordingly.
        </p>

        <h4>REFUNDS</h4>

        <p>
          South Central Institute of Technology has a 'no refunds' policy which
          means that we do not give refunds other than in the circumstances
          detailed below. Once you have signed the enrolment form, you have
          agreed to the following terms and conditions as far as fees are
          concerned. Refunds may only be considered if one or more of the
          following circumstances exist:
        </p>

        <ul style={{ listStyleType: "upper-roman" }}>
          <li>The Institute terminates a course.</li>
          <li>
            The Institute does not provide an advertised course and is unable to
            provide suitable alternative provision
          </li>
          <li>
            The Institute materially alters the time or location of a course
            from that advertised
          </li>
          <li>
            The Institute recommends a student transfers to a course with a
            lower fee
          </li>
          <li>
            The Institute has overcharged a student or assessed their fees
            incorrectly
          </li>
          <li>
            Medical conditions, certified by appropriate medical professionals,
            resulting in the student having to leave the Institute completely.
          </li>
          <li>
            You notify the Institute, in writing, prior to the course start
            date. A full refund of total fees paid will be refunded, less a £50
            administration fee. (A refund request form must be received by the
            Institute on or before 14 days after the start of the course).
          </li>
        </ul>
        <p>
          If after enrolment, you decide to withdraw from your course for any
          other reason than above, you shall not be entitled to a refund. If we
          have agreed for you to pay in instalments then you must pay all unpaid
          instalments immediately.
        </p>

        <p>
          Refund applications will only be considered if received on a correctly
          completed form, available from all Institute receptions. Where refunds
          are declined, the Institute may issue a credit note or voucher for
          another Institute course as an alternative. Where the Institute
          terminates a course, which has already started, you will receive a
          full refund of all amounts paid; however, all other refunds and credit
          notes will be subject to deductions for classes already attended, the
          examination fee where the Institute has already registered your entry
          and an administration fee of £50.00.
        </p>

        <h4>FEE POLICY</h4>

        <p>
          The full Institute Fees Policy is available on our website or upon
          request from Customer Services.
        </p>

        <h4>EXAMINATIONS / REGISTRATIONS</h4>

        <p>
          It is your responsibility to ensure that all examination and awarding
          body registrations are made on your behalf.
        </p>

        <h4>DEFINITION OF RELEVANT CRIMINAL CONVICTIONS</h4>

        <p>
          By relevant criminal convictions, the Institute means convictions for
          offences against the person, whether of a violent or sexual nature,
          and convictions for offences involving unlawful supply or use of
          controlled drugs or substances. You do not have to tell us about any
          convictions that are spent (as defined by the Rehabilitation of
          Offenders Act 1974), or about any cautions, reprimands or final
          warnings. For further advice on whether convictions are unspent,
          please contact NACRO on 020 7840 6464.
        </p>

        <h4>FAIR PROCESSING NOTICE</h4>

        <p>
          The Education and Skills Funding Agency is a public body that funds
          qualifications and training that you may be receiving. The Education
          and Skills Funding Agency may obtain and use third party reference
          data to assist when verifying your ULN and when checking that the data
          it holds about you is correct, in order to comply with the
          requirements of the Data Protection Act 1998 to keep your details
          accurate and up to date The information you supply will be used by the
          Education and Skills Funding Agency, an executive agency of the
          Department for Education (DfE), to issue you with a Unique Learner
          Number (ULN), and to create your Personal Learning Record. For more
          information about how your information is processed and shared refer
          to the Extended Privacy Notice available on{" "}
          <a href="https://www.gov.uk" target="_blank">
            https://www.gov.uk
          </a>{" "}
          You can opt-out of sharing your participation and achievement data by
          contacting the Learning Records Service customer helpdesk on 0345 602
          2589. For further details of how your information is shared and used
          by the Learning Records Service please visit the Learning Records
          Service website at{" "}
          <a
            href="https://www.gov.uk/guidance/how-to-access-your-personal-learning-record"
            target="_blank"
          >
            https://www.gov.uk/guidance/how-to-access-your-personal-learning-record
          </a>
        </p>

        <p>
          I give permission for the South Central Institute of Technology to
          contact me with communications other than those essential to the
          process, with news, event invitations and useful information that may
          be of interest.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Checkbox
          label="By ticking this box, I confirm that I have read the declaration above and agree to the statements within it. Ticking this box replaces my signature on this electronic form"
          name="Declaration"
          register={register}
          validation={{
            required:
              "Please tick this box after reading the above declaration",
          }}
          error={errors.Declaration}
        />

        <button type="submit" className="form-submit" disabled={isSubmitting}>
          {isSubmitting ? "Saving" : "Submit"}
        </button>
      </form>
    </>
  );
};

export default Declaration;
